export default __webpack_public_path__ + "static/media/slide2.6261c133.jpg";